import React, { useState } from 'react'
import SvgIcon from '../svg-icon/svg-icon'
import { Button, Dropdown, Menu } from 'semantic-ui-react'
import { Link, useLocation, useHistory } from 'react-router-dom'
import MediaQuery from 'react-responsive'
import './index.scss'
import GlobalSearch from '../../../components/common/layout/navbar/gloabalSearch'

const NavBar = () => {
    const location = useLocation();
    return (
        <Menu stackable borderless>
            <Menu.Item className='ecosystem-menu' text="" as={Link} to="/ecosystem">Ecosystem</Menu.Item>
            <Dropdown item className={location.pathname === "/ecosystem" ? "active ecosystem-usbmenu" : "ecosystem-usbmenu"}  icon={<SvgIcon name='chevron-bottom' viewbox="0 0 14 8" />}>
                <Dropdown.Menu>
                    <Dropdown.Item as={Link} to="/ecosystem/solar" text="Solar" />
                    <Dropdown.Item as={Link} to="/ecosystem/additive-manufacturing" text="Additive Manufacturing" />
                    <Dropdown.Item as={Link} to="/ecosystem/optical-fiber" text="Optical Fiber and Cable" />
                    <Dropdown.Item as={Link} to="/ecosystem/lithium-ion" text="Lithium-ion Battery" />
                    <Dropdown.Item as={Link} to="/ecosystem/semiconductors" text="Semiconductors" />
                    <Dropdown.Item as={Link} to="/ecosystem/green-hydrogen" text="Green Hydrogen" />
                    <Dropdown.Item as={Link} to="/ecosystem/carbon-fiber" text="Carbon Fiber" />
                    <Dropdown.Item as={Link} to="/ecosystem/uv-eb-curing" text="UV/EB Curing" />
                </Dropdown.Menu>
            </Dropdown>
            <Menu.Item as={Link} className={location.pathname === "/mappes-network" ? "active" : ""} to="/mappes-network" name="Mappes Network" />
            <Menu.Item as={Link} className={location.pathname === "/value-chain" ? "active" : ""} to="/value-chain" name="Value Chain" />
            <Menu.Item as={Link} className={location.pathname === "/aboutus" ? "active" : ""} to="/aboutus" name="About Us" />
            <Menu.Item as={Link} className={location.pathname === "/event" ? "active" : ""} to="/event" name="Events" />
            <Menu.Item as={Link} className={location.pathname === "/careers" ? "active" : ""} to="/careers" name="Careers" />
            <Menu.Item as={Link} className={location.pathname === "/articles" ? "active" : ""} to="/articles" name="Articles" />
        </Menu>
    )
}

const SlideBarMenu = ({ isOpen, toggle, otp_login }) => {



    return (
        <div className={`slidebar-mobile ${isOpen ? 'open' : ''}`}>
            <div className='menu-upper'>
                <div className='menu-logo'>
                    <SvgIcon className='logo-icon' name='mappes-logo' viewbox="0 0 136 16" />
                    <button className="close-btn" onClick={toggle}>
                        <SvgIcon name='close-icon' viewbox="0 0 18 18" />
                    </button>
                </div>
                <NavBar />
            </div>
            <Button primary className='signin-btn' onClick={() => otp_login()}>Sign In</Button>
        </div>
    );
};

const Header = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const history = useHistory();

    const toggleSlideBar = () => {
        setIsOpen(!isOpen);
    };

    const toggleSearch = () => {
        setIsSearchOpen(!isSearchOpen);
    };

    const otp_login = () => {
        console.log('in here ')
        history.push('/otp-login');
    }
    return (
        <div className='mappes-header'>
            <div className='mappes-container'>
                <div className='mappes-header-inner'>
                    <div className='header-left'>
                        <Link to='/'>
                            <SvgIcon name='mappes-logo' viewbox="0 0 136 16" />
                        </Link>
                    </div>
                    <div className='header-center'>
                        <MediaQuery minWidth={992}>
                            <NavBar />
                        </MediaQuery>
                        {isSearchOpen &&
                            <div className={isSearchOpen ? "center-search search-opened" : "center-search"}>
                                <GlobalSearch />
                                <Button className='search-close' onClick={toggleSearch}>
                                    <SvgIcon name='close-icon' viewbox="0 0 18 18" />
                                </Button>
                            </div>
                        }
                        <Button className='search-btn' onClick={toggleSearch}>
                            <SvgIcon name='search' viewbox="0 0 20 20" />
                        </Button>
                    </div>
                    <div className='header-right'>
                        <MediaQuery minWidth={992}>
                            <Button primary onClick={() => otp_login()}>Sign In</Button>
                        </MediaQuery>
                        <MediaQuery maxWidth={991}>
                            <button primary onClick={toggleSlideBar} className='menu-icon'><SvgIcon name='menus-icon' viewbox="0 0 20 14" /></button>
                        </MediaQuery>
                        <SlideBarMenu isOpen={isOpen} toggle={toggleSlideBar} otp_login={otp_login} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Header